import { __awaiter, __generator } from "tslib";
import { popoverDriver } from '../../primitives/popover/driver';
import { createFloaterMenuDriver } from '../floater-menu/driver';
export var createLocalePickerDriver = function (wrapper, global) {
    var base = wrapper.$(".locale-picker");
    var popover = popoverDriver(global);
    var openMenu = function () { return base.$('.deprecated-link-button').click(); };
    var isMenuOpen = function () { return popover.$(".locale-menu-wrapper").exists(); };
    return {
        getPickedLocaleText: function () { return base.$('.picked-locale').text(); },
        getPickedLocale: function () { return base.$('.picked-locale').attr('data-value'); },
        pickLocale: function (locale) { return __awaiter(void 0, void 0, void 0, function () {
            var elem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popover.$(".locale-menu-wrapper")];
                    case 1:
                        elem = _a.sent();
                        return [4 /*yield*/, openMenu()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, isMenuOpen()];
                    case 3:
                        if (!_a.sent()) return [3 /*break*/, 5];
                        return [4 /*yield*/, createFloaterMenuDriver(elem).selectByValue(locale)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); },
        isLocaleDisabled: function (idx) { return __awaiter(void 0, void 0, void 0, function () {
            var menu;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$('.deprecated-link-button').click()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, popover.$(".locale-menu-wrapper")];
                    case 2:
                        menu = _a.sent();
                        return [2 /*return*/, createFloaterMenuDriver(menu).disabled(idx)];
                }
            });
        }); },
        getMenuitems: function () { return __awaiter(void 0, void 0, void 0, function () {
            var elem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popover.$(".locale-menu-wrapper")];
                    case 1:
                        elem = _a.sent();
                        return [4 /*yield*/, openMenu()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, isMenuOpen()];
                    case 3:
                        if (_a.sent()) {
                            return [2 /*return*/, createFloaterMenuDriver(elem).getItems()];
                        }
                        return [2 /*return*/, []];
                }
            });
        }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map